import { LOCAL_STORAGE_KEYS } from '../constants';
export function isAiQuickReply(reply) {
    var _a, _b;
    return ((_b = (_a = reply.metadata) === null || _a === void 0 ? void 0 : _a.client) === null || _b === void 0 ? void 0 : _b.aiQuickReply) === true;
}
export function getReplyTimestamp(reply) {
    var _a, _b, _c, _d;
    return (_d = (_b = (_a = reply.metadata) === null || _a === void 0 ? void 0 : _a.updated) !== null && _b !== void 0 ? _b : (_c = reply.metadata) === null || _c === void 0 ? void 0 : _c.created) !== null && _d !== void 0 ? _d : 0;
}
export function filterQuickRepliesForChat(replies, chat) {
    if (!(chat === null || chat === void 0 ? void 0 : chat.channelInfo))
        return [];
    const { channelInfo, _id: chatId } = chat;
    return replies.filter((reply) => reply.send.target.some((target) => {
        if (target.name !== channelInfo.name || target.accountId !== channelInfo.accountId)
            return false;
        if (target.id && target.id !== chatId)
            return false;
        return true;
    }));
}
export function getSeenMap() {
    try {
        const raw = localStorage.getItem(LOCAL_STORAGE_KEYS.SEEN_AI_QUICK_REPLIES);
        if (!raw)
            return {};
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' ? parsed : {};
    }
    catch (error) {
        console.error('Error reading from storage, seen map not updated', error);
        return {};
    }
}
function writeSeenMap(map) {
    // defaulting to local storage
    try {
        localStorage.setItem(LOCAL_STORAGE_KEYS.SEEN_AI_QUICK_REPLIES, JSON.stringify(map));
    }
    catch (error) {
        /* storage disabled or full — non-fatal */
        console.error('Error writing to storage, seen map not updated', error);
    }
}
export function markSeen(chatId, replies) {
    if (!chatId || !replies.length)
        return;
    const map = getSeenMap();
    const chatEntry = Object.assign({}, (map[chatId] || {}));
    let changed = false;
    for (const reply of replies) {
        const ts = getReplyTimestamp(reply);
        if (chatEntry[reply._id] !== ts) {
            chatEntry[reply._id] = ts;
            changed = true;
        }
    }
    if (!changed)
        return;
    map[chatId] = chatEntry;
    writeSeenMap(map);
}
export function hasUnseenAiReply(chatId, aiReplies) {
    if (!chatId || !aiReplies.length)
        return false;
    const chatEntry = getSeenMap()[chatId] || {};
    return aiReplies.some((reply) => chatEntry[reply._id] !== getReplyTimestamp(reply));
}
